<template>
  <div id="threeconect">
    <button class="buttonclass" type="button" @click="toggle">
      Fullscreen
    </button>
    <fullscreen :fullscreen.sync="fullscreen">
      <div class="alert_hide">
        <span
          class="closebtn"
          onclick="this.parentElement.style.display='none';"
          >&times;</span
        >
        <strong>Danger!</strong> Indicates a dangerous or potentially negative
        action.
      </div>
      <div class="showinfo">
        <!--左上边框-->
        <div class="t_line_box">
          <i class="t_l_line"></i>
          <i class="l_t_line"></i>
        </div>
        <!--右上边框-->
        <div class="t_line_box">
          <i class="t_r_line"></i>
          <i class="r_t_line"></i>
        </div>
        <!--左下边框-->
        <div class="t_line_box">
          <i class="l_b_line"></i>
          <i class="b_l_line"></i>
        </div>
        <!--右下边框-->
        <div class="t_line_box">
          <i class="r_b_line"></i>
          <i class="b_r_line"></i>
        </div>
        <div class="showinfo_con">
          <div class="showinfo_con_title">
            <p>Area arrangement</p>
          </div>
          <canvas id="myChart"></canvas>
          <div class="showinfo_con_title_2">
            <p style="color: #fff">Top 5 area</p>
          </div>
          <canvas id="myChart2"></canvas>
        </div>
      </div>
      <div class="three" id="three">
        <div class="tag" id="tag"></div>

        <!-- <div class="loading" id="loading">
          <div class="bb"></div>
          <h1 id="Modelinfo" style="color: #fff">Model</h1>
          <p id="info_p"></p>

          <h2 class="top cal_i" id="info_all" style="color: #fff"></h2>
          <i class="icon-calendar"></i>
        </div> -->
      </div>
    </fullscreen>
  </div>
</template>
<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { GUI } from "three/examples/jsm/libs/dat.gui.module";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass.js";
import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader.js";
import axios from "axios";
import fullscreen from "vue-fullscreen";
import $ from "jquery";
import { d3 } from "d3";
import Vue from "vue";

Vue.use(fullscreen);
export default {
  data() {
    return {
      job: {
        enable: true,
        id: null,
      },
      fullscreen: false,
    };
  },
  mounted() {
    this.initThree();
  },
  destroyed() {
    this.job.enable = false;
    clearTimeout(this.job.id);
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    },
    initThree() {
      const scene = new THREE.Scene();
      scene.background = new THREE.Color("#eee");
      var wristband;

      var Mapmodel;
      var mixer = null;
      var childrenModel = new Array();
      var allchild = new Array();
      var allchildcount;
      var checkfirstloadmodel = true;
      //model
      const fbxLoader = new FBXLoader();
      var actions = []; //所有的动画数组
      const camera = new THREE.PerspectiveCamera(
        50,
        window.innerWidth / window.innerHeight,
        0.1,
        10000
      );
      var renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        logarithmicDepthBuffer: true,
      });
      // 设置渲染区域尺寸，本质就是设置输出canvas的尺寸
      // 把渲染器的渲染结果canvas对象插入到'pos'对应的div元素中
      document.getElementById("three").appendChild(renderer.domElement);
      renderer.shadowMap.enabled = true;
      renderer.setClearAlpha(0.2);
      var axis = new THREE.AxesHelper(200);
      scene.add(axis);
      /*
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(window.innerWidth, window.innerHeight);
      */
      addEventListener("dblclick", onMouseDblclick, false);
      camera.position.set(200, 200, 400);
      //http

      this.job.id = setInterval(() => {
        axios
          .get(
            process.env.VUE_APP_API+'api/staff/Wristband/random-data'
          )
          .then((response) => {
            if (this.job.enable) {
              this.wristband = response.data.result;
            }
          })
          .catch(function (error) {
            //console.log(error);
          });

        if (this.wristband != null) {
          allchildcount = Object.keys(this.wristband).length;
          for (var i = 0; i < allchildcount; i++) {
            allchild[i] = [
              this.wristband[i].x,
              this.wristband[i].y,
              this.wristband[i].wristbandId,
            ];
            //console.log(this.wristband[i].wristbandId);
            //console.log(allchild[i]);
            //Mapmodel.position.x = allchild[i][0]
          }
          if (checkfirstloadmodel) {
            //console.log("just do 1");
            checkfirstloadmodel = false;
            var calcount = 0;
            if (allchildcount != null) {
              //console.log("i iiiiii allchildcount is " + allchildcount);
              for (var countc = 0; countc < allchildcount; countc++) {
                fbxLoader.load(
                  "/Model/3.fbx",
                  (fbx) => {
                    //console.log("the x is " + childrenModel.length)
                    childrenModel[calcount] = fbx;

                    //console.log(calcount);
                    mixer = new THREE.AnimationMixer(childrenModel[calcount]);
                    //console.log(childrenModel[calcount].animations);
                    actions[calcount] = mixer.clipAction(
                      childrenModel[calcount].animations[0]
                    );

                    THREE.ImageUtils.crossOrigin = "anonymous";
                    const loader = new THREE.TextureLoader();
                    loader.setCrossOrigin("anonymous");
                    //const mapOverlay = loader.load(allchild[calcount].icon);

                    var temp = this.wristband[calcount].icon;
                    //console.log("the url is " + temp);
                    childrenModel[calcount].traverse(function (child) {
                      if (child instanceof THREE.Mesh) {
                        //设置模型皮肤
                        THREE.ImageUtils.crossOrigin = "anonymous";
                        child.material.map = THREE.ImageUtils.loadTexture(
                          //"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcKUD3ZlBYPOTI2fBb0OgeQgwYSKwf4lDZJw&usqp=CAU"
                          temp
                        );
                      }
                    });

                    childrenModel[calcount].name = allchild[calcount][2];
                    childrenModel[calcount].position.x = allchild[calcount][0];
                    childrenModel[calcount].position.z = allchild[calcount][1];
                    childrenModel[calcount].scale.set(0.1, 0.1, 0.1);
                    scene.add(childrenModel[calcount]);

                    //set alert
                    var status = this.wristband[calcount].status;
                    if (status == "Warning") {
                      $(".alert_hide").addClass("alert_3dmap");
                      $(".alert_3dmap").removeClass("alert_hide");
                    }

                    calcount++;
                  },
                  (xhr) => {
                    //console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
                  },
                  (error) => {
                    //console.log(error);
                  }
                );
              }
            }
          }
          if (!checkfirstloadmodel) {
            try {
              for (var i = 0; i < allchild.length; i++) {
                childrenModel[i].position.x = allchild[i][0];
                childrenModel[i].position.z = allchild[i][1];
              }
            } catch (e) {
              //console.log(e);
            }
          }
        }
      }, 2000);

      //close loading bar
      $("#loading").click(function () {
        $(this).remove();
      });

      //Model

      fbxLoader.load(
        "/Model/map.fbx",
        (fbx) => {
          Mapmodel = fbx;
          scene.add(Mapmodel);
        },
        (xhr) => {
          var str;
          str = (xhr.loaded / xhr.total) * 100;
          $("#Modelinfo").text("Model load " + str + " %");
          $("#info_all").text(
            "欢迎使用 3D 地图的实时预览。 这是一个实验性功能。 用鼠标左键拖动以移动视角。 阅读完以上内容后，单击窗口将其关闭。"
          );
        },
        (error) => {
          //console.log(error);
        }
      );

      //model 2

      /*
      for (var count = 0; count < 1; count++) {
        fbxLoader.load(
          "/Model/3.fbx",
          (fbx) => {
            childrenModel[count] = fbx;

            mixer = new THREE.AnimationMixer(childrenModel[count]);
            console.log(childrenModel[count].animations);
            //var AnimationAction = mixer.clipAction(
            //  childrenModel[count].animations[0]
            //);

            THREE.ImageUtils.crossOrigin = "";
            var texture = THREE.ImageUtils.loadTexture(
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRO7A9jrJXya9Wp6nK5jvEiXBMAzGwiCHTUWw&usqp=CAU"
            );
            childrenModel[count].traverse(function (child) {
              if (child instanceof THREE.Mesh) {
                //设置模型皮肤
                child.material.map = texture;
              }
            });
            var AnimationAction = mixer.clipAction(
              childrenModel[count].animations[0]
            );
            //childrenModel[count].material = texture;
            childrenModel[count].scale.set(0.1, 0.1, 0.1);
            console.log("this is textture");
            console.log(childrenModel[count].material);
            //childrenModel[count].position.x = allchild[count][0];
            //console.log("thes is " + this.wristband[0].x);
            scene.add(childrenModel[count]);
            AnimationAction.play();
          },
          (xhr) => {
            console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
          },
          (error) => {
            console.log(error);
          }
        );
      }
*/

      //light
      const skycolor = new THREE.Color(0x424242);
      scene.background = skycolor;
      const hemLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);
      hemLight.position.set(0, 48, 0);
      scene.add(hemLight);

      const dirLight = new THREE.DirectionalLight(0xffffff, 1);
      //光源等位置
      dirLight.position.set(-10, 8, -5);
      //可以产生阴影
      //dirLight.castShadow = true;
      //dirLight.shadow.mapSize = new THREE.Vector2(512, 512);
      const helper = new THREE.DirectionalLightHelper(dirLight, 10);
      scene.add(dirLight);
      //scene.add(dirLight);

      let floorGeometry = new THREE.PlaneGeometry(1, 1);
      let floorMaterial = new THREE.MeshPhongMaterial({
        color: 0x8a8a8a,
        shininess: 0,
      });
      let floor = new THREE.Mesh(floorGeometry, floorMaterial);
      floor.rotation.x = -0.5 * Math.PI;
      floor.receiveShadow = true;
      floor.position.y = -0.001;
      scene.add(floor);

      const controls = new OrbitControls(camera, renderer.domElement);
      controls.maxPolarAngle = Math.PI * 0.495;
      controls.target.set(0, 10, 0);
      controls.enableDamping = true;
      controls.update();

      //---------gui

      var gui = new GUI();
      var controlsc = new (function () {
        // this.FullScreen = function () {
        //   this.fullscreen = !this.fullscreen
        //   console.log(this.fullscreen)
        // };
      })();
      var options = {
        resetcamera: function () {
          controls.reset();
        },
        velx: 0,
        vely: 0,
        camera: {
          speed: 0.0001,
        },
        edgeStrength: 3.0,
        edgeGlow: 0.0,
        edgeThickness: 1.0,
        pulsePeriod: 0,
        rotate: false,
        usePatternTexture: false,
        stop: function () {
          this.velx = 0;
          this.vely = 0;
        },
        reset: function () {
          this.velx = 0.1;
          this.vely = 0.1;
          camera.position.z = 75;
          camera.position.x = 0;
          camera.position.y = 0;
          cube.scale.x = 1;
          cube.scale.y = 1;
          cube.scale.z = 1;
          cube.material.wireframe = true;
        },
      };
      var velocity = gui.addFolder("Setting");
      velocity.add(options, "resetcamera");
      // velocity
      //   .add(options, "edgeStrength", 0.01, 10)
      //   .onChange(function (value) {
      //     outlinePass.edgeStrength = Number(value);
      //   });

      // velocity.add(options, "edgeGlow", 0.0, 10).onChange(function (value) {
      //   outlinePass.edgeGlow = Number(value);
      // });

      // velocity.add(options, "edgeThickness", 1, 4).onChange(function (value) {
      //   outlinePass.edgeThickness = Number(value);
      // });

      // velocity.add(options, "pulsePeriod", 0.0, 5).onChange(function (value) {
      //   outlinePass.pulsePeriod = Number(value);
      // });

      velocity.add(options, "rotate");

      // velocity.add(options, "usePatternTexture").onChange(function (value) {
      //   outlinePass.usePatternTexture = value;
      // });

      function Configuration() {
        this.visibleEdgeColor = "#ffffff";
        this.hiddenEdgeColor = "#190a05";
      }

      const conf = new Configuration();

      // velocity.addColor(conf, "visibleEdgeColor").onChange(function (value) {
      //   outlinePass.visibleEdgeColor.set(value);
      // });

      // velocity.addColor(conf, "hiddenEdgeColor").onChange(function (value) {
      //   outlinePass.hiddenEdgeColor.set(value);
      // });

      // 创建一个时钟对象Clock
      var clock = new THREE.Clock();

      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();

      var selectedObject; //被选中的物体
      var boundingBox;
      var selected; //被选中的物体位置
      var isselectpeople = false;
      function onMouseMove(event) {
        mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
        mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

        var vector = new THREE.Vector3(); //三维坐标对象
        vector.set(
          (event.clientX / window.innerWidth) * 2 - 1,
          -(event.clientY / window.innerHeight) * 2 + 1,
          0.5
        );
        vector.unproject(camera);
        var intersectss = raycaster.intersectObjects(scene.children);
        if (intersectss.length > 0) {
          selected = intersectss[0]; //取第一个物体
          isselectpeople = true;
          //console.log("x坐标:" + selected.point.x);
          //console.log("y坐标:" + selected.point.y);
          //console.log("z坐标:" + selected.point.z);
        } else {
          isselectpeople = false;
        }
      }
      const materials = createMaterials();
      const selection = [];
      function createMaterials() {
        const main = new THREE.MeshStandardMaterial({
          color: 0xcccccc,
          flatShading: true,
          transparent: true,
          opacity: 0.8,
        });

        main.color.convertSRGBToLinear();

        const highlight = new THREE.MeshStandardMaterial({
          color: 0xff4444,
          flatShading: true,
        });

        highlight.color.convertSRGBToLinear();

        return {
          main,
          highlight,
        };
      }

      var movecam = false,
        tempx,
        tempz;

      //model outline
      let selectedObjects = [];
      let composer, effectFXAA, outlinePass;
      composer = new EffectComposer(renderer);

      const renderPass = new RenderPass(scene, camera);
      composer.addPass(renderPass);

      outlinePass = new OutlinePass(
        new THREE.Vector2(window.innerWidth, window.innerHeight),
        scene,
        camera
      );
      composer.addPass(outlinePass);

      const textureLoader = new THREE.TextureLoader();
      textureLoader.load("model/icontest.png", function (texture) {
        outlinePass.patternTexture = texture;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
      });
      effectFXAA = new ShaderPass(FXAAShader);
      effectFXAA.uniforms["resolution"].value.set(
        1 / window.innerWidth,
        1 / window.innerHeight
      );
      composer.addPass(effectFXAA);

      function addSelectedObject(object) {
        selectedObjects = [];
        selectedObjects.push(object);
      }

      //double click mouse
      function onMouseDblclick(event) {
        // 获取 raycaster 和所有模型相交的数组，其中的元素按照距离排序，越近的越靠前
        if (!movecam) {
          movecam = true;
        }
      }

      //render
      function animate() {
        controls.update();
        renderer.render(scene, camera);
        requestAnimationFrame(animate);

        raycaster.setFromCamera(mouse, camera);

        const intersects = raycaster.intersectObjects(childrenModel, true); //just select child

        if (intersects.length > 0) {
          $("#tag").show();

          selectedObject = intersects[0].object;

          addSelectedObject(selectedObject);
          outlinePass.selectedObjects = selectedObjects;
          //动态标签
          var str = new String("");
          var div = document.getElementById("tag");

          var position = new THREE.Vector3(
            selectedObject.parent.position.x,
            selectedObject.parent.position.y,
            selectedObject.parent.position.z
          );
          var windowPosition = transPosition(position);
          var left = windowPosition.x;
          var top = windowPosition.y;
          //console.log(selectedObject.parent.position);
          div.style.position = "absolute";
          div.style.display = "";
          div.style.left = left + 50 + "px";
          div.style.top = top - 50 + "px";
          div.style.border = "solid 2px";

          str =
            "名称：" +
            intersects[0].object.parent.name +
            " <br />坐标：  x=" +
            left +
            "   y=" +
            top;

          var selectobject = scene.getObjectByName(
            intersects[0].object.parent.name,
            true
          );
          tempx = selectobject.position.x;
          tempz = selectobject.position.z;
          //console.log(selectobject)
          var clickedID = intersects[0].object.uuid;
          var clickedName = intersects[0].object.parent.name;
          //console.log("You clicked: " + clickedName);
          //console.log("UUID: " + clickedID);
          div.innerHTML = str;
          //new image div
        }
        //没有选中物体就移除包围盒
        else {
          if (boundingBox) {
            Pscene.remove(boundingBox);
          }
          //str = "";
          $("#tag").hide();
        }

        //cam move
        // if (movecam) {
        //     controls.target.x = Math.trunc(controls.target.x)
        //     controls.target.y = Math.trunc(controls.target.y)
        //     controls.target.z = Math.trunc(controls.target.z)
        //   if (controls.target.x != tempx || controls.target.x != tempz) {
        //     //small
        //     if (controls.target.x > tempx ) {
        //       controls.target.x -= 1;
        //     }
        //     if (controls.target.x < tempx ) {
        //       controls.target.x += 1;
        //     }
        //     if (controls.target.z > tempz) {
        //       controls.target.z -= 1;
        //     }
        //     if (controls.target.z < tempz ) {
        //       controls.target.z += 1;
        //     }
        //     //console.log("x is " + controls.target.x + " " + tempx  + " and " + controls.target.z + " " + tempz)
        //     if (controls.target.x == tempx && controls.target.z == tempz) {
        //       console.log("yesssssssssss")
        //       movecam = false;
        //     }
        //   }
        // }
        // if (movecam && isselectpeople) {
        //   controls.target.x = tempx;
        //   controls.target.y = Math.trunc(controls.target.y);
        //   controls.target.z = tempz;

        //   if (controls.target.x == tempx && controls.target.z == tempz) {
        //     movecam = false;
        //   }
        // }
        //--updata div ui
        //divRender();

        composer.render();
        const timer = performance.now();
        if (options.rotate) {
          scene.rotation.y = timer * 0.0001;
        }
        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }
        if (mixer !== null) {
          //clock.getDelta()方法获得两帧的时间间隔
          // 更新混合器相关的时间
          mixer.update(clock.getDelta());
        }
      }

      animate();
      window.addEventListener("mousemove", onMouseMove, false);

      //new add test------------------------
      function divRender(x, y, z) {
        //计算三维坐标对应的屏幕坐标
        var position = new THREE.Vector3(20, 60, 50);
        var windowPosition = transPosition(position);
        var left = windowPosition.x;
        var top = windowPosition.y;
        //设置div屏幕位置
        let div = document.getElementById("tag");
        div.style.display = "";
        div.style.left = left + "px";
        div.style.top = top + "px";

        //just do one time
        // var addDivDom = document.getElementById("tag");
        // // addDivDom.id=cube.uuid+"_text";
        // var img = new Image();
        // // var image=document.createElement("img");
        // var image_src = "TEST.png";
        // img.src = image_src;
        // addDivDom.appendChild(img);
        // var point = new THREE.Vector3(20, 60, 50);
        // var windowPosition1 = transPosition(point);
        // var left = windowPosition1.x;
        // var top = windowPosition1.y;
        // console.log("push something");
        // addDivDom.style.display = "";
        // addDivDom.style.left = left + "px";
        // addDivDom.style.top = top + "px";
      }

      function transPosition(position) {
        let world_vector = new THREE.Vector3(
          position.x,
          position.y,
          position.z
        );
        let vector = world_vector.project(camera);
        let halfWidth = window.innerWidth / 2,
          halfHeight = window.innerHeight / 2;
        return {
          x: Math.round(vector.x * halfWidth + halfWidth),
          y: Math.round(-vector.y * halfHeight + halfHeight),
        };
      }

      //--------------------------------------

      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        var width = window.innerWidth;
        var height = window.innerHeight;
        var canvasPixelWidth = canvas.width / window.devicePixelRatio;
        var canvasPixelHeight = canvas.height / window.devicePixelRatio;

        const needResize =
          canvasPixelWidth !== width || canvasPixelHeight !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
          composer.setSize(width, height);

          effectFXAA.uniforms["resolution"].value.set(
            1 / window.innerWidth,
            1 / window.innerHeight
          );
        }
        return needResize;
      }

      Chart.defaults.global.defaultFontColor = "#fff";

      //chart js
      var ctx = document.getElementById("myChart").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              label: "# of Votes",
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: [
                "rgba(255,99,132,1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Chart.js Doughnut Chart",
            },
          },
        },
      });
      //chart js2
      var ctx = document.getElementById("myChart2").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              label: "# of Votes",
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderColor: [
                "rgba(255,99,132,1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          responsive: true,
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Chart.js Bar Chart",
            },
          },
        },
      });
    },
  },
};
</script>

<style scope>
#three {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
.tag {
  --border-width: 3px;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: Lato, sans-serif;
  text-transform: uppercase;

  background-color: rgb(226, 255, 255);
  border: solid 2px rgb(0, 233, 250);

  border-color: #222;
  border-radius: var(--border-width);
}
.buttonclass {
  position: absolute;
}

.dg.main.taller-than-window .close-button {
  border-top: 1px solid #ddd;
}

.dg.main .close-button {
  background-color: #ccc;
}

.dg.main .close-button:hover {
  background-color: #ddd;
}

.dg {
  color: #555;
  text-shadow: none !important;
}

.dg.main::-webkit-scrollbar {
  background: #fafafa;
}

.dg.main::-webkit-scrollbar-thumb {
  background: #bbb;
}

.dg li:not(.folder) {
  background: #fafafa;
  border-bottom: 1px solid #ddd;
}

.dg li.save-row .button {
  text-shadow: none !important;
}

.dg li.title {
  background: #e8e8e8
    url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==)
    6px 10px no-repeat;
}

.dg .cr.function:hover,
.dg .cr.boolean:hover {
  background: #fff;
}

.dg .c input[type="text"] {
  background: #e9e9e9;
}

.dg .c input[type="text"]:hover {
  background: #eee;
}

.dg .c input[type="text"]:focus {
  background: #eee;
  color: #555;
}

.dg .c .slider {
  background: #e9e9e9;
}

.dg .c .slider:hover {
  background: #eee;
}

.loading {
  font-family: "Open Sans", arial;
  position: absolute;
  top: 30%;
  left: 35%;
  width: 30%;
  height: 30%;
  background: #1e90ff;
  overflow: hidden;
  font-size: 5px;
  padding: 10px;
  display: block;
  float: left;
  margin: 5px;
}

.loading:hover {
  -webkit-transform: scale(1.05);
}

.loading:active {
  -webkit-transform: scale(1);
}

.cal_e h1 {
  font-family: "Open Sans", arial;
  position: absolute;
  right: 0px;
  text-align: center;
  margin: 0px;
  font-size: auto;
}
.cal_e p {
  font-family: "Open Sans", arial;
  position: absolute;
  right: 0px;
  text-align: center;
  margin-top: 75px;
  text-transform: uppercase;
  font-size: auto;
}
.cal_e i {
  text-align: left;
  font-size: auto;
  position: absolute;
  bottom: 0px;
}

.bb::before,
.bb::after,
.bb {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.bb {
  width: 150px;
  height: 150px;
  margin: auto;
  background: url("../assets/images/WePark Logo-01.png") no-repeat 50%/70%
    rgba(0, 0, 0, 0.1);
  color: #69ca62;
  box-shadow: inset 0 0 0 1px rgb(255, 255, 255);
  top: 200px;
  left: 300px;
}
.bb::before,
.bb::after {
  content: "";
  z-index: -1;
  margin: -5%;
  box-shadow: inset 0 0 0 10px;
  animation: clipMe 8s linear infinite;
}
.bb::before {
  animation-delay: -4s;
}

@keyframes clipMe {
  0%,
  100% {
    clip: rect(0px, 140px, 2px, 0px);
  }
  25% {
    clip: rect(0px, 2px, 140px, 0px);
  }
  50% {
    clip: rect(218px, 220px, 220px, 0px);
  }
  75% {
    clip: rect(0px, 220px, 220px, 218px);
  }
}

.alert_3dmap {
  padding: 20px;
  background-color: #4813da;
  color: white;
  position: absolute;
  opacity: 0.6;
  right: 0;
  bottom: 70px;
}

.alert_hide {
  visibility: hidden;
  position: absolute;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.showinfo {
  color: white;
  position: absolute;
  opacity: 0.6;
  left: 1%;
  top: 10%;
  background-image: linear-gradient(to right, #686868, #4d4d4d);
  width: 400px;
  height: 600px;
  box-shadow: 0 0 10px #2c58a6;
}

.showinfo_con {
  color: #fff;
  font-size: 30px;
  padding: 25px 25px;
}
.showinfo_con_title {
  color: #fff;
  font-size: 35px;
  text-align: center;
}
.showinfo_con_title_2 {
  color: #fff;
  font-size: 25px;
  padding-top: 45px;
}
.l_t_line {
  width: 5px;
  height: 24px;
  left: -3px;
  top: -3px;
}
.t_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  top: -3px;
}
.t_line_box {
  position: absolute;
  width: 100%;
  height: 100%;
}
.t_line_box i {
  background-color: #4788fb;
  box-shadow: 0px 0px 10px #4788fb;
  position: absolute;
}
.t_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  top: -3px;
}
.r_t_line {
  width: 5px;
  height: 24px;
  right: -3px;
  top: -3px;
}
.l_b_line {
  width: 5px;
  height: 24px;
  left: -3px;
  bottom: -3px;
}
.b_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  bottom: -3px;
}
.r_b_line {
  width: 5px;
  height: 24px;
  right: -3px;
  bottom: -3px;
}
.b_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  bottom: -3px;
}
</style>